import * as z from "zod";

export const approveSettingsChanges = {
  name: "approveSettingsChanges" as const,
  input: z.object({ changeIds: z.array(z.string()).min(1) }),
  output: z.object({
    applied: z.number(),
    /** Changes the approver lacks bypass access to the owning group for. */
    skippedUnauthorized: z.number(),
    /** Settings for a returns center whose addition is still pending; accept or reject it first. */
    heldForReturnsCenter: z.number(),
  }),
};

export const rejectSettingsChanges = {
  name: "rejectSettingsChanges" as const,
  input: z.object({ changeIds: z.array(z.string()).min(1) }),
  output: z.object({
    rejected: z.number(),
    /** Changes the caller may not delete (not an approver nor the proposer). */
    skippedUnauthorized: z.number(),
  }),
};
